import React from "react";
import '../styles/Home.scss';

import Header from '../components/Header';
import Login from '../components/Login';


function Home() {
    return (
        <div>
            <Header/>
            <Login/>
        </div>
)
};

export default Home;
